import { RESERVATION } from "@/routes/_constants/query-params/management";

export const ReservationTypeForSearchReservationList = {
	CHECK_IN: RESERVATION.SEARCH_TYPE.VALUE.CHECK_IN,
	CHECK_OUT: RESERVATION.SEARCH_TYPE.VALUE.CHECK_OUT,
	STAY_DATE: RESERVATION.SEARCH_TYPE.VALUE.STAY_DATE,
	UPDATED_DATE: RESERVATION.SEARCH_TYPE.VALUE.UPDATED_DATE,
	RESERVATION_ID: RESERVATION.SEARCH_TYPE.VALUE.RESERVATION_ID,
} as const;

export type ReservationTypeForSearchReservationList =
	(typeof ReservationTypeForSearchReservationList)[keyof typeof ReservationTypeForSearchReservationList];
